/**
 * React Query key for a startup's data-room access view, in one place so every
 * reader (Team Access, Billing, admin panel) and every mutation that changes
 * access invalidates the same cache entry (ADR FE-1).
 */
export const dataRoomAccessKeys = {
  all: ['data-room-access'] as const,
  forStartup: (startupId: string) => ['data-room-access', startupId] as const,
};

/**
 * React Query key for a startup's Premium period history (MYN-258, admin
 * only). Its own root rather than nested under `dataRoomAccessKeys`, so
 * member screens that refresh the access view do not also refetch an
 * admin-only resource; every Premium mutation invalidates both explicitly.
 */
export const premiumHistoryKeys = {
  forStartup: (startupId: string) => ['data-room-premium-history', startupId] as const,
};
